export const OBSERVER_CALLBACK_DEFAULT_THROTTLE = 250
export const OBSERVER_DEFAULT_ROOT_MARGIN = '100px'
